import { parse } from './core/parse';
import { format } from './core/format';
import { onLog, offLog } from './core/log';

export { parse, format, onLog, offLog };
export default {
  parse,
  format,
  onLog,
  offLog,
};
